/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum PlaybackContentType {
    LIVE,
    STARTOVER_BEGINNING,
    STARTOVER_RESUME,
    CATCHUP_BEGINNING,
    CATCHUP_RESUME,
    NDVR_LIVE,
    NDVR_RECORDED,
}
